<img src="assets/mockup/electricity-ranking.svg" alt="">